import { useState } from 'react';
import { isEqual } from 'lodash';
import {
  GssSettingLeftHandednessData,
  WdtSettingLeftHandednessData
} from 'types/schema-generated-types';

const DEFAULT_LEFTHANDEDNESS = { leftHanded: false, rtlCrossStroke: false };

const useLeftHandedness = (
  setting: GssSettingLeftHandednessData | WdtSettingLeftHandednessData | null
): any => {
  const initialState: any = setting || DEFAULT_LEFTHANDEDNESS;
  const [leftHanded, setLeftHanded] = useState(initialState.leftHanded);
  const [rtlCrossStroke, setRtlCrossStroke] = useState(initialState.rtlCrossStroke);
  const leftHandedness = { leftHanded, rtlCrossStroke };

  return {
    leftHandedness,
    hasLeftHandednessChanged: !isEqual(leftHandedness, initialState),
    toggleLeftHanded: (): void => setLeftHanded(!leftHanded),
    toggleRtlCrossStroke: (): void => setRtlCrossStroke(!rtlCrossStroke)
  };
};

export default useLeftHandedness;
